import React, { Component } from 'react';
import EnhancedTableHead from './EnhancedTableHead.index';
import PropTypes from "prop-types";
import download from '../images/download-doc.svg';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Button } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import { Tooltip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {
   
  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

const rows = [
    { id: "temperature", numeric: false, disablePadding: false, label: "Temperature", padding: '10px' },
    { id: "date", numeric: false, disablePadding: false, label: "Date", padding: '10px' },
]

const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    }
    ,
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    primaryButton: {
        background: '#6cca98',
        color: '#fff',
        '&:hover': {
          background: '#6cca98',
          color: '#fff',
        },
        '&:disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
          cursor: 'not-allowed',
          background: '#E4E5E8'
        },
    }

});

const TemperatureFilterObj = {
    searchText: '',
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: '',
    fromdate: '',
    todate: '',
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class TemparatureHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            order: 'desc',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            loader: false,
            isDataEmpty: true,
            totalRecords : 0,
            isOpenDialog: false,
            temperatureRecords: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
        }
    }

    componentDidMount() {
        // Set default date range (T-30 days to today)
        const defaultDates = getDefaultDateRange();
        this.setState({ 
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });
        TemperatureFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
        TemperatureFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
        this.BindTemperatureHistory();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }
    
    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, dateRangePreset: '' });
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindTemperatureHistory();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, dateRangePreset: '' });
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindTemperatureHistory();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindTemperatureHistory();
    }
    
    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindTemperatureHistory();
    }
    
    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;
        
        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset
        });
        
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        TemperatureFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindTemperatureHistory();
    };

    onSearchChange = (event) => {
        const searchString = event.target.value;
        if (searchString.length > 3) {
            this.setState({ searchText: searchString });
            TemperatureFilterObj.pageNo = 0;
            TemperatureFilterObj.sortOrder = 'desc';
            TemperatureFilterObj.sortColumn = 'created_on';
            TemperatureFilterObj.tableName = '';
            TemperatureFilterObj.searchText = searchString;
            this.BindTemperatureHistory();
        }
    }

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        const { data } = this.state;
        TemperatureFilterObj.pageNo = page;
        if (data && data.length > 0) {
            this.BindTemperatureHistory();
        }
    }

    handleChangeRowsPerPage = (event) => {
        const { data } = this.state;
        TemperatureFilterObj.pageNo = 0;
        TemperatureFilterObj.pageSize = event.target.value;
        if (data && data.length > 0) {
            this.BindTemperatureHistory();
        }
    }

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['box'].includes(field)) {
            tablename = 'boxes';
        }
        if(['store'].includes(field)){
            tablename = 'accounts'
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy, sortId: property });
        TemperatureFilterObj.sortOrder = order;
        TemperatureFilterObj.sortColumn = field;
        TemperatureFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        const { data } = this.state;
        if (data && data.length > 0) {
            this.BindTemperatureHistory();
        }
    };

    exportCSV() {
        this.setState({loader: true});
        fetch(process.env.REACT_APP_BASEURL + 'CSV/TemperatureHistoryReport', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TemperatureFilterObj)
        })
        .then(response => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then(res => {
              this.setState({ loader: false })
              let csvRow=[];
              let A=[[`Id`,'Store','Location','Side','Temperature','Connect With', 'Date']];
              let re = res && res.Results && res.Results.length > 0 ? res.Results : [];
              if(re !== undefined){
                  if(re && re.length > 0)
                  {
                      for(let item=0; item < re.length; item++){
                          A.push([
                              re[item].store,
                              re[item].boxname,
                              re[item] && re[item].direction === 1 ? 'Left' : 'Right',
                              re[item].temperature,
                              re[item].connectedwith,
                              re[item].temperature_timestamp ? this.convertToTimeZone(re[item].temperature_timestamp) : '',
                          ]);
                      }
                      for(let i=0; i<A.length; i++){
                          csvRow.push(A[i].join(","));
                      }
                      let csvString=csvRow.join("%0A");
                      let a = document.createElement("a");
                      a.href='data:attachment/csv.'+csvString;
                      a.target="_Blank";
                      a.download="TemperatureHistory.csv";
                      document.body.appendChild(a);
                      a.click();
                  }
              }
          })
    }

    BindTemperatureHistory() {
        this.setState({ loader: true,data: null });
        fetch(process.env.REACT_APP_BASEURL + 'temperature/history/reports', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TemperatureFilterObj)
        })
        .then(response => {
            try{
                return response.json();
            }catch(error){
                return error;
            }
        }).then(async(tempData) => {
            this.setState({  })
            if(tempData && tempData.results && tempData.results.length > 0){
                this.setState({data: tempData && tempData.results, totalRecords: tempData && tempData.total });
                setTimeout(() => {
                    this.setState({ loader: tempData && tempData.total && false, isDataEmpty: false })
                }, 5000)
            }
            else{
                this.setState({ data : null, loader:false, isDataEmpty:true});
            }
        })
    }

    handleOpenDialog(expansionId){
        this.setState({ isOpenDialog: !this.state.isOpenDialog });
        this.fetchTemperatureRecords(expansionId);
    }

    ConfirmClose(){
        this.setState({ isOpenDialog: false })
    }

    fetchTemperatureRecords = (data) => {
        let requestparams = {
            "expansionId": data
        }
        this.setState({ loader: true, temperatureRecords: null });
        fetch(process.env.REACT_APP_BASEURL + 'temperature/expansion', {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestparams)
        }).then(response => {
            try{
                return response.json();
            }catch(error){
                return error;
            }
        }).then(res => {
            if(res && res.length > 0){
                this.setState({ temperatureRecords: res, loader: false, isDataEmpty: false });
            }else{
                this.setState({ temperatureRecords: null, loader: false , isDataEmpty: true});

        }
        })
    }

    render() {
        const { classes, t } = this.props;
        const { totalRecords, data, temperatureRecords, locale, fromdate, todate, dateRangePreset } = this.state;
        return (
            <div>
                {
                    this.state.loader ? (
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div>) :
                        (null)
                }

                <Dialog open={this.state.isOpenDialog} fullWidth={true} maxWidth={'md'} >
                        <DialogTitle>
                            {t("Report.TemperatureHis.TemperatureHistoryTitle")}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                        {rows && rows.map(row => {
                                            return (
                                                <TableCell
                                                key={row.id}
                                                numeric={row.numeric}
                                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}>{row.label}
                                                </TableCell>
                                                )
                                            })}
                                            </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!temperatureRecords ? (
                                        <TableRow>
                                            <TableCell colSpan={20} style={{ textAlign: "center", padding:'10px 0px' }}>
                                                {this.state.isDataEmpty && t("Report.TemperatureHis.NoDataFoundText")}
                                            </TableCell>
                                        </TableRow>
                                        ):
                                            temperatureRecords.length && temperatureRecords.length > 0 &&
                                            temperatureRecords.map(n => {
                                                return (
                                                    <TableRow sx={{ height: '45px'}}>
                                                        <TableCell>{n.temperature}</TableCell>
                                                        <TableCell>{n.temperature_timestamp ? this.convertToTimeZone(n && n.temperature_timestamp) : ''}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => this.ConfirmClose()} color="primary" className={classes.primaryButton}>
                            {t("Report.TemperatureHis.Cancel")}
                        </Button>
                        </DialogActions>
                </Dialog>

                <div>
                    <Table className={classes.table}>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ width: '15%', borderBottom: 'none' }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                                        <Select
                                            value={dateRangePreset}
                                            onChange={this.handleDateRangePresetChange}
                                            variant="standard"
                                            label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                                        >
                                            <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                                            <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                                            <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                                            <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: '12%', borderBottom: 'none' }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                            <DesktopDatePicker
                                                disableFuture
                                                keyboard
                                                value={fromdate}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        label={t("Report.Transaction.FromDate")}
                                                        variant="standard"
                                                        allowKeyboardControl={true}
                                                        onBlur={this.handleBlurfrom}
                                                    />
                                                }
                                                onChange={this.onFromDateSelect}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: '12%', borderBottom: 'none' }}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                            <DesktopDatePicker
                                                disableFuture
                                                keyboard
                                                value={todate}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        label={t("Report.Transaction.ToDate")}
                                                        variant="standard"
                                                        allowKeyboardControl={true}
                                                        onBlur={this.handleBlurtodate}
                                                    />
                                                }
                                                onChange={this.onToDateSelect}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </TableCell>
                                <TableCell style={{ width: '18%', borderBottom: 'none' }}>
                                    <TextField
                                        id="idsearchtext"
                                        defaultValue=""
                                        value={this.state.searchText}
                                        label={t("Report.TemperatureHis.Search")}
                                        className={classes.formControl}
                                        fullWidth
                                        onChange={this.onSearchChange}
                                        inputProps={{
                                            autocomplete: 'new-search',
                                            form: {
                                                autocomplete: 'off'
                                            },
                                        }}
                                        variant="standard"
                                    />
                                </TableCell>
                                <TableCell style={{ width: "15%", borderBottom: "none", textAlign: "right" }}>
                                    <Tooltip key="single-edit" title={t("Report.TemperatureHis.ExportCSVTooltip")}>
                                        <IconButton
                                            onClick={() => { this.exportCSV() }}
                                        >
                                            <img alt="download" src={download} onClick={() => { this.exportCSV() }} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <EnhancedTableHead
                            order={TemperatureFilterObj.sortOrder}
                            orderBy={TemperatureFilterObj.sortColumn}
                            sortId={this.state.sortId}
                            onRequestSort={this.handleRequestSort}
                        />
                        <TableBody>
                            {!data ? (
                                <TableRow>
                                    <TableCell colSpan={20} style={{ textAlign: "center" }}>
                                        {this.state.isDataEmpty && t("Report.TemperatureHis.NoDataFoundText")}
                                    </TableCell>
                                </TableRow>
                            ) :
                                data.length && data.length > 0 &&
                                stableSort(data, getSorting(TemperatureFilterObj.sortOrder, TemperatureFilterObj.sortColumn))
                                    .map(n => {
                                        return (
                                            <TableRow>
                                                <TableCell className={classes.padding10px}>{n.store}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.boxName}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.direction === 1 ? 'Left' : 'Right'}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.connectedWith}</TableCell>
                                                <TableCell className={classes.padding10px}>
                                                  <Tooltip title='View'>
                                                   <IconButton aria-label="Delete"  onClick={() => this.handleOpenDialog(n.expansionId)}
                                                   sx={() => ({ '&:hover': { backgroundColor: '#6cca98', color: '#fff' } }) }>
                                                     <TableViewOutlinedIcon/>
                                                   </IconButton>
                                                  </Tooltip>
                                                 </TableCell>
                                            </TableRow>
                                        )
                                    })
                            }
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalRecords || 0}
                        rowsPerPage={TemperatureFilterObj.pageSize}
                        page={TemperatureFilterObj.pageNo}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </div>
        )
    }
}

TemparatureHistory.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withTranslation()(TemparatureHistory));



// WEBPACK FOOTER //
// ./src/components/reports/temparature_history/index.js